import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ArbeitsbereichService } from '../../../shared/service/arbeitsbereich.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { takeUntil } from 'rxjs/operators';
import { TakeUntilDestroy } from '../../../core/component/take-until-destroy';
import { AgGridListViewService } from '../../services/ag-grid-list-view.service';
import { AgGridNotifyService } from '../../services/ag-grid-notify.service';
import { SelectionService } from '../../../shared/service/selection.service';

@Component({
    selector: 'ag-grid-list-view',
    templateUrl: './ag-grid-list-view.component.html',
    styleUrls: ['./ag-grid-list-view.component.scss'],
    standalone: false
})
export class AgGridListViewComponent extends TakeUntilDestroy implements OnInit, OnDestroy {
  @ViewChild('agGridListviewRef', { static: true }) agGridListviewRef: ElementRef;
  @ViewChild('tabsetRef', { static: true }) tabsetRef: TabsetComponent;

  // which tab is active, gets changed on tabclick
  public activeTabLayer: any;
  public listViewTabConfigs = [];

  constructor(
    private agGridlistViewService: AgGridListViewService,
    private arbeitsbereichService: ArbeitsbereichService,
    private agGridNotifyService: AgGridNotifyService,
    private selectionService: SelectionService
  ) {
    super();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngOnInit() {
    this.arbeitsbereichService.onChangeArbeitsbereichSubject.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.agGridlistViewService.getListViewTabConfig().subscribe(tabs => {
        this.listViewTabConfigs = tabs;
        if (this.listViewTabConfigs?.length > 0) {
          this.setActiveTabLayer(this.listViewTabConfigs[0].tabLayer.url);
          this.agGridlistViewService.setActiveTabId(this.listViewTabConfigs[0].tabLayer.url);
        }
      });
    });
  }

  /* Public methods, for use in templates
  =========================== */
  /**
   * @function onSelectTab
   * @param selectedTab
   * @description Set the new selected Tab and notify for table refresh
   */
  public onSelectTab(selectedTab) {
    this.setActiveTabLayer(selectedTab.id);
    this.agGridlistViewService.setActiveTabId(selectedTab.id);
    this.selectionService.removeAllSelectedGraphics();
    this.agGridNotifyService.selectedTabChanged(selectedTab);
  }

  /**
   * sets the active tabLayer when the user clicks on a tab. The id of selectedTab is the url
   * @param selectedTabId
   */
  private setActiveTabLayer(selectedTabId: string) {
    this.activeTabLayer = this.listViewTabConfigs.find(l => l.tabLayer.url === selectedTabId).tabLayer;
  }
}
